<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container
            fill-height
            fluid
            grid-list-xl
    >
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">

        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h5 class="mt-3">환경설정 및 메시지 작성</h5>
                    <div class="card mt-1 pb-1">
                        <div class="card-body">
                            <div class="form-row">
                                <div class="form-group col">
                                    <small class="form-text text-muted">Host</small>
                                    <select class="form-control form-control-sm" id="parking-host">
                                        <option value="ws://roadster-stress.devel.kakao.com/cable">Staging</option>
                                        <option value="wss://parking-sandbox.kakao.com/cable">Sandbox</option>
                                        <option value="wss://parking.kakao.com/cable">Production</option>
                                    </select>
                                </div>
                                <div class="form-group col">
                                    <small class="form-text text-muted">Token</small>
                                    <input class="form-control form-control-sm" id="parking-token" type="text" value="FXQ2rqqVx7" placeholder="주차장 토큰 입력">
                                </div>
                                <div class="form-group col">
                                    <small class="form-text text-muted">Code</small>
                                    <input class="form-control form-control-sm" id="parking-code" type="text" value="22574132" placeholder="주차장 코드 입력">
                                </div>
                            </div>
                            <input class="btn btn-sm btn-outline-primary" id="btn-connect" type="button" value="Connect & Subscribe" @click="connect()">
                            <input class="btn btn-sm btn-outline-danger" id="btn-disconnect" type="button" value="Disconnect" @click="disconnect()">
                        </div>
                    </div>
                    <div class="card mt-2">
                        <div class="card-body">
                            <div class="form-group">
                                <small class="form-text text-muted">이벤트 목록</small>
                                <select class="form-control form-control-sm" id="event-selector">
                                    <option value="" disabled selected>Select your option</option>
                                    <option value='{"type":"request","name":"car_entered", "number":1}'> 1. 입차</option>
                                    <option value='{"type":"request","name":"car_number_updated", "number":2}'> 2. 차량번호 갱신</option>
                                    <option value='{"type":"request","name":"entrance_time_updated", "number":3}'> 3. 입차시각 갱신</option>
                                    <option value='{"type":"response","name":"register_kakao", "number":4}'> 4. 카카오 T 차량 등록</option>
                                    <option value='{"type":"response","name":"auto_exit_updated", "number":5}'>  5. 카카오 T 차량 자동 출차 변경</option>
                                    <option value='{"type":"response","name":"cancel_kakao", "number":6}'> 6. 카카오 T 차량 해지</option>
                                    <option value='{"type":"request","name":"car_paid", "number":7}'> 7. 일반 차량 정산</option>
                                    <option value='{"type":"request","name":"car_exited", "number":8}'> 8. 일반 차량 출차</option>
                                    <option value='{"type":"request","name":"kakao_exited", "number":9}'> 9. 카카오 T 차량 출차</option>
                                    <option value='{"type":"request","name":"request_kakao_payment", "number":10}'> 10. 카카오 T 차량 결제 요청 (카카오요금)</option>
                                    <option value='{"type":"request","name":"register_discount", "number":11}'> 11. 할인 등록</option>
                                    <option value='{"type":"request","name":"modify_discount", "number":12}'> 12. 할인 수정</option>
                                    <option value='{"type":"request","name":"cancel_discount", "number":13}'> 13. 할인 취소</option>
                                    <option value='{"type":"request","name":"request_kakao_payment", "number":14}'> 14. 카카오 T 차량 결제 요청 (현장요금)</option>
                                    <option value='{"type":"response","name":"register_discount_key", "number":15}'> 15. 할인키 등록</option>
                                    <option value='{"type":"response","name":"cancel_discount_key", "number":16}'> 16. 할인키 해지</option>
                                    <option value='{"type":"response","name":"check_parking_rates", "number":17}'> 17. 현재 요금 조회</option>
                                    <option value='{"type":"response","name":"check_car_records", "number":18}'> 18. 입출차 내역 조회</option>
                                    <option value='{"type":"response","name":"check_car_status", "number":19}'> 19. 차량 등록 정보 조회</option>
                                    <option value='{"type":"response","name":"check_parked_location", "number":20}'> 20. 차량 주차 위치 조회</option>
                                    <option value='{"type":"request","name":"occupancy_report", "number":21}'> 21. 주차장 점유 정보</option>
                                    <option value='{"type":"response","name":"cancel_kakao_payment", "number":22}'> 22. 카카오 T 결제 취소</option>
                                    <option value='{"type":"response","name":"register_barcode", "number":23}'> 23. 바코드 등록</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <small class="form-text text-muted">일반 입출차 ID</small>
                                <div class="input-group">
                                    <input class="form-control form-control-sm" id="field-id" type="text" placeholder="일반 입출차 ID 입력">
                                    <div class="input-group-append">
                                        <button class="btn btn-sm btn-outline-secondary" id="btn-field-id-refresh"type="button">refresh</button>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <small class="form-text text-muted">카카오 입출차 ID</small>
                                <input class="form-control form-control-sm" id="kakao-id" type="text" value="" placeholder="카카오 입출차 ID 입력">
                            </div>
                            <div class="form-group">
                                <small class="form-text text-muted">차량번호</small>
                                <input class="form-control form-control-sm" id="car-number" type="text" value="07노0391" placeholder="차량번호 입력">
                            </div>
                            <div class="form-row">
                                <div class="form-group col">
                                    <small class="form-text text-muted">차량번호 전체 (암호화)</small>
                                    <input class="form-control form-control-sm" id="car-full-encrypted" type="text" value="" disabled="true">
                                </div>
                                <div class="form-group col">
                                    <small class="form-text text-muted">차량번호 숫자 (암호화)</small>
                                    <input class="form-control form-control-sm" id="car-number-encrypted" type="text" value="" disabled="true">
                                </div>
                            </div>
                            <div class="form-group">
                                <small class="form-text text-muted">Event Params or Reponse Result</small>
                                <textarea class="form-control form-control-sm text-monospace" id="por" rows="14"></textarea>
                            </div>
                            <input class="btn btn-sm btn-outline-primary" id="btn-send" type="button" value="Send Message">
                        </div>
                    </div>
                </div>
                <!-- col end -->
                <div class="col">
                    <h5 class="mt-3">서버로 보낸 메시지</h5>
                    <div class="form-group mt-1">
                        <textarea class="form-control form-control-sm text-monospace" id="sending-message" rows="44" disabled></textarea>
                    </div>
                </div>
                <!-- col end -->
                <div class="col">
                    <h5 class="mt-3">서버에서 받은 메시지</h5>
                    <div class="form-group mt-1">
                        <textarea class="form-control form-control-sm text-monospace" id="incoming-message" rows="44" disabled></textarea>
                    </div>
                </div>
                <!-- col end -->
            </div>
            <!-- row end -->
        </div>
        <!-- container end -->
    </v-container>
</template>

<script>

  import StatsCard from '../components/material/StatsCard'
  import Test from '../components/core/Test'
  import UserButton from '../components/core/UserButton'
  import tool_app from '../utils/tool_app'

  export default {
    // export default {
    components: {UserButton, Test, StatsCard,},
    data () {
      return {
        client: null,
        dialog: false,

      };
    },
    created: function() {
      console.log('created 2222');

// this.$loadScript('https://code.jquery.com/jquery-3.3.1.slim.min.js')
// .then(() => {
// // Script is loaded, do something
// console.log('asd 1');
// })
// .catch(() => {
// // Failed to fetch script
// });
// this.$loadScript('https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js')
// .then(() => {
// // Script is loaded, do something
// console.log('asd 2');
// })
// .catch(() => {
// // Failed to fetch script
// });
// this.$loadScript('https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js')
// .then(() => {
// // Script is loaded, do something
// console.log('asd 3');
// })
// .catch(() => {
// // Failed to fetch script
// });
    },
    beforeDestroy: function() {
      tool_app.lg('beforeDestroy 1');
      this.disconnect();
    },
    methods: {
      complete (index) {
        this.list[index] = !this.list[index]
      },
      connect() {
      // <option value="wss://roadster-stress.devel.kakao.com/cable">Staging</option>
      // <option value="wss://parking-sandbox.kakao.com/cable">Sandbox</option>
      // <option value="wss://parking.kakao.com/cable">Production</option>
        let host = 'wss://parking-sandbox.kakao.com/cable';
        let token = 'TEksdsd7f9w';
        tool_app.lg('connect 1 client: ', this.client);
        // if(this.client === undefined || this.client === null) {
        if(! this.client) {
          this.client = new WebSocket(host, [token]);

          try {
            this.client.onopen = this.onopen;
            // this.client.onopen = function() {
            //   tool_app.lg('WebSocket Client Connected 1111');
            //   // setScreenState("connected");
            //   // incomingMessage.value += "\r\n" + "[CONNECTED]" + "\r\n";
            //   // onSendClick("subscribe");
            //   // setFieldId();
            //   this.methods.send('subscribe');
            //   tool_app.lg('WebSocket Client Connected 232123');
            // };

            this.client.onclose = function() {
              tool_app.lg('WebSocket Client Closed');
              // setScreenState("disconnected");
              // incomingMessage.value += "\r\n" + "[DISCONNECTED]" + "\r\n";
            };

            this.client.onerror = function() {
              tool_app.lg('WebSocket Connection Error');
            };

            this.client.onmessage = function(e) {
              // console.log("WebSocket onmessage e: ", e);
              let wsMsg = e.data;
              let hashMsg = JSON.parse(wsMsg);

              if (hashMsg['type'] !== 'ping') {
                tool_app.lg("WebSocket MESSAGE: ", wsMsg);
                // if (wsMsg.indexOf("error") > 0) {
                //   incomingMessage.value += "\r\n" + wsMsg.error + "\r\n";
                // } else if ('message' in hashMsg) {
                //   incomingMessage.value += "\r\n" + hashMsg['message'] + "\r\n";
                // } else {
                //   incomingMessage.value += "\r\n" + wsMsg + "\r\n";
                // }
                // incomingMessage.scrollTop = incomingMessage.scrollHeight;
              }
            };

          } catch (exception) {
            // console.error(exception);
            tool_app.ex(exception);
          }
        }

      },
      onopen() {
        tool_app.lg('WebSocket Client Connected 1111');
          // setScreenState("connected");
          // incomingMessage.value += "\r\n" + "[CONNECTED]" + "\r\n";
          // onSendClick("subscribe");
          // setFieldId();
          this.send('subscribe');
          tool_app.lg('WebSocket Client Connected 232123');
      },
      disconnect() {
        tool_app.lg('disconnect 1 this.client:', this.client);
        if(this.client) {
          console.log(this.client.readyState);
          // console.log(WebSocket.OPEN);
          this.client.close();
        }
      },
      send(command) {
        tool_app.lg('send 1 command:', command);
        tool_app.lg('send 2 this.client:', this.client);
        tool_app.lg('send 3 this.client.readyState:', this.client.readyState);
        // check websocket is open
        if (this.client === null || this.client.readyState !== WebSocket.OPEN) {
          alert("webSocket is not open");
          return;
        }

        var payload = {};
        var data = {};
        var msg = {};
        var identifier = "{\"channel\":\"ParkingLotChannel\", \"test\": \"true\"}";

        if (command === "subscribe") {
          // composite subscribe msg
          msg.command = command;
          msg.identifier = identifier;
        } else {
          var eventValue = JSON.parse(document.getElementById("event-selector").value);
          var type = eventValue.type;
          var eventName = eventValue.name;
          var por = JSON.parse(document.getElementById("por").value);

          // composite payload
          payload.parking_lot_token = document.getElementById("parking-token").value;
          payload.event_name = eventName;
          payload.event_type = type;
          payload.field_id = document.getElementById("field-id").value;
          payload.car_full = document.getElementById("car-full-encrypted").value;
          payload.car_number = document.getElementById("car-number-encrypted").value;
          var kakaoId = document.getElementById("kakao-id").value;
          if (kakaoId != ""){
            payload.kakao_id = kakaoId;
          }
          if (type == "request") {
            payload.params = por;
          } else if (type == "response") {
            payload.response = por;
          } else {
            console.log("something wrong");
          }

          // composite data
          data.action = type;
          data.payload = payload;

          // composite msg
          msg.command = "message";
          msg.identifier = identifier;
          msg.data = JSON.stringify(data);

        }

        // send message
        this.client.send(JSON.stringify(msg));
      },
      test () {
        console.log('test');
      },
    }
  };
</script>
